<div>
  <span class="text_size-s text_color-03">{{ label }}</span>
  <ng-content></ng-content>
</div>
